<template>
  <div class="img-box" :style="boxStyle" ref="box">
      <img
          v-if="showImg"
          :src="hostSrc"
          :alt="alt"
          :style="imgStyle"
          ref="img"
          @error="onerror">
      <div class="loading" v-if="loading">
        <img src="./imgs/loading.png" style="width:16px;height:16px">
      </div>
      <div class="fail" v-if="fail && !stationImgServerFail">
        <img src="./imgs/fail.png" style="width:24px;height:24px">
      </div>
      <span v-if="!src || (stationImgServerFail && !showImg && !loading)" class="img-box-empty" :height="height" :minHeight="minHeight">{{ text }}</span>
  </div>
</template>
<style lang="scss" scoped>
@import "img-base.theme";
.loading {
  img {
    animation: mymove 2s infinite linear;
  }
  @keyframes mymove {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
.img-box {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #f2f2f2;
  color: #999;
}
img {
  height: 100%;
  width: 100%;
  cursor: pointer;
}
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/img-base/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/img-base/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/img-base/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-img-base')
  export default {
    name: 'base-img-base', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-img-base': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>